import { Record } from "immutable";
import { EventType } from "models/enumerations/events/event-type";
import { ToolCallEvent } from "models/interfaces/events/tool-call-event";

const defaultValues: ToolCallEvent = {
    type: EventType.ToolCallAction,
    sessionId: "",
    toolCallEvent: {
        toolCallId: "",
        action: undefined,
    },
};

export default class ToolCallEventRecord
    extends Record(defaultValues)
    implements ToolCallEvent
{
    constructor(params: Partial<ToolCallEvent> = {}) {
        super(params ?? defaultValues);
    }
}
